import {
  ThunderboltOutlined,
  DatabaseOutlined,
  FormOutlined,
  BranchesOutlined,
  StarOutlined,
  SendOutlined,
  TagsOutlined,
  ApiOutlined,
  RetweetOutlined,
  QuestionOutlined,
} from "@ant-design/icons";

// Groups shown in the left sidebar
export const NODE_GROUPS = [
  {
    label: "Trigger",
    items: [
      { type: "message", label: "New Message", icon: "ThunderboltOutlined" },
      {
        type: "keyword-alert",
        label: "Keyword Alert",
        icon: "ThunderboltOutlined",
      },
    ],
  },
  {
    label: "AI",
    items: [
      { type: "call-llm", label: "Call LLM", icon: "StarOutlined" },
      {
        type: "smart-auto-reply",
        label: "Smart Auto-Reply",
        icon: "StarOutlined",
      },
    ],
  },
  {
    label: "Data",
    items: [
      {
        type: "database-connect",
        label: "Database Connect",
        icon: "DatabaseOutlined",
      },
      { type: "rag-query", label: "RAG Query", icon: "DatabaseOutlined" },
    ],
  },
  {
    label: "Actions",
    items: [
      {
        type: "send-message",
        label: "Send Message",
        icon: "SendOutlined",
      },
      {
        type: "apply-tag",
        label: "Apply Tag",
        icon: "TagsOutlined",
      },
    ],
  },
  {
    label: "Integration",
    items: [
      {
        type: "external-api",
        label: "External API",
        icon: "ApiOutlined",
      },
    ],
  },
  {
    label: "Control",
    items: [
      {
        type: "condition",
        label: "Condition",
        icon: "BranchesOutlined",
      },
      {
        type: "loop",
        label: "Loop",
        icon: "RetweetOutlined",
      },
    ],
  },
];

// Icon lookup so both the sidebar and the canvas nodes can render the same icon
export const ICONS = {
  ThunderboltOutlined,
  DatabaseOutlined,
  FormOutlined,
  BranchesOutlined,
  StarOutlined,
  SendOutlined,
  TagsOutlined,
  ApiOutlined,
  RetweetOutlined,
  QuestionOutlined
};
